import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSelector } from 'react-redux';
import Header from '../../../../header';
import Footer from '../../../../footer';
import CustomInput from '../../../../../components/customInput';
import CustomButton from '../../../../../components/customButton';
import { langSelector } from '../../../../../store/langSlice';
import getEnvironement, { getLang } from '../../../../../environnement';
import CustomSelect from '../../../../../components/customSelect';
import { useNavigate } from 'react-router-dom';

function InscriptionConfirm({
  open,
  handleClose
}) {
  const navigate = useNavigate();
  const lang = useSelector(langSelector);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{paddingBottom: '0px'}}
    >
      <DialogTitle id="alert-dialog-title">
        <p className='text-2xl sm:text-3xl font-medium font-inter mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscription}</p>
        
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscriptionContent[0]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscriptionContent[1]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscriptionContent[2]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscriptionContent[3]}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className='flex justify-end px-5 w-full'>
          <div
            className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-[180px]'
            onClick={() => {
              handleClose();
              navigate('/');
            }}
          >
            <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.accord}</p>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default function Inscription({
  activeItem
}) {
  const [nom1, setNom1] = useState('');
  const [nom2, setNom2] = useState('');
  const [nom3, setNom3] = useState('');
  const [nom4, setNom4] = useState('');
  const [coach, setCoach] = useState('');
  const [ville, setVille] = useState('');
  const [pays, setPays] = useState('');
  const [autrePays, setAutrePays] = useState('');
  const [tel, setTel] = useState('');
  const [email, setEmail] = useState('');
  const [nationalite, setNationalite] = useState('');
  const [profession, setProfession] = useState('');
  const [typeParticipation, setTypeParticipation] = useState('');

  const [nom1Error, setNom1Error] = useState('');
  const [nom2Error, setNom2Error] = useState('');
  const [nom3Error, setNom3Error] = useState('');
  const [nom4Error, setNom4Error] = useState('');
  const [coachError, setCoachError] = useState('');
  const [villeError, setVilleError] = useState('');
  const [paysError, setPaysError] = useState('');
  const [autrePaysError, setAutrePaysError] = useState('');
  const [telError, setTelError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [nationaliteError, setNationaliteError] = useState('');
  const [professionError, setProfessionError] = useState('');
  const [typeParticipationError, setTypeParticipationError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openInscriptionConfirm, setOpenInscriptionConfirm] = useState(false);

  const lang = useSelector(langSelector);

  const sendInscription = async () => {
    const url = `${getEnvironement().API_URL}/inscriptionFirstWorldCup`;
    const data = {
      lang,
      nom1,
      nom2,
      nom3,
      nom4,
      coach,
      pays,
      ville,
      autrePays: pays === 'Maroc' ? '-' : autrePays,
      tel,
      email,
      nationalite,
      profession,
      typeParticipation
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setOpenBackdrop(false))
      // .then(() => toast.success(getLang(lang).firstWorldCup.inscriptionSuccess))
      .then(() => setOpenInscriptionConfirm(true))
      .then(() => {
        setNom1('');
        setNom2('');
        setNom3('');
        setNom4('');
        setEmail('');
        setPays('');
        setVille('');
        setAutrePays('');
        setCoach('');
        setTel('');
        setTypeParticipation('');
        setNom1Error('');
        setNom2Error('');
        setNom3Error('');
        setNom4Error('');
        setEmailError('');
        setPaysError('');
        setVilleError('');
        setAutrePaysError('');
        setCoachError('');
        setTelError('');
        setNationaliteError('');
        setProfessionError('');
        setTypeParticipationError('');
      })
      .catch((err) => {
        console.log(err);
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          toast.error(getLang(lang).firstWorldCup.inscriptionError);
          err.response.data.errors.nom1 ? setNom1Error(err.response.data.errors.nom1[0]) : setNom1Error('');
          err.response.data.errors.nom2 ? setNom2Error(err.response.data.errors.nom2[0]) : setNom2Error('');
          err.response.data.errors.nom3 ? setNom3Error(err.response.data.errors.nom3[0]) : setNom3Error('');
          err.response.data.errors.nom4 ? setNom4Error(err.response.data.errors.nom4[0]) : setNom4Error('');
          err.response.data.errors.email ? setEmailError(err.response.data.errors.email[0]) : setEmailError('');
          err.response.data.errors.ville ? setVilleError(err.response.data.errors.ville[0]) : setVilleError('');
          err.response.data.errors.pays ? setPaysError(err.response.data.errors.pays[0]) : setPaysError('');
          err.response.data.errors.autrePays ? setAutrePaysError(err.response.data.errors.autrePays[0]) : setAutrePaysError('');
          err.response.data.errors.coach ? setCoachError(err.response.data.errors.coach[0]) : setCoachError('');
          err.response.data.errors.tel ? setTelError(err.response.data.errors.tel[0]) : setTelError('');
          err.response.data.errors.nationalite ? setNationaliteError(err.response.data.errors.nationalite[0]) : setNationaliteError('');
          err.response.data.errors.profession ? setProfessionError(err.response.data.errors.profession[0]) : setProfessionError('');
          err.response.data.errors.typeParticipation ? setTypeParticipationError(err.response.data.errors.typeParticipation[0]) : setTypeParticipationError('');
        }
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <ToastContainer />
      <InscriptionConfirm
        open={openInscriptionConfirm}
        handleClose={() => setOpenInscriptionConfirm(false)}
      />
      <Backdrop
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          color: '#A31732',
          zIndex: 2000
        }}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header activeItem={activeItem} />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] px-10 my-10'>
          <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6'style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.inscriptionTitle}</p>
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.nom1}
            value={nom1}
            setValue={setNom1}
            isError={nom1Error !== ''}
            error={nom1Error}
          />
          <CustomSelect
            items={[
              {id: 2, value: 'Résident', label: getLang(lang).firstWorldCup.professionItems[1]},
              {id: 3, value: 'Spécialiste', label: getLang(lang).firstWorldCup.professionItems[2]},
              {id: 4, value: 'Para médical', label: getLang(lang).firstWorldCup.professionItems[3]},
            ]}
            placeholder={getLang(lang).firstWorldCup.profession}
            value={profession}
            setValue={setProfession}
            isError={professionError !== ''}
            error={professionError}
          />
          <CustomSelect
            items={[
              {id: 0, value: 'Participant à la compétition', label: getLang(lang).firstWorldCup.typeParticipationItems[0]},
              {id: 1, value: 'Spéctateur', label: getLang(lang).firstWorldCup.typeParticipationItems[1]},
            ]}
            placeholder={getLang(lang).firstWorldCup.typeParticipation}
            value={typeParticipation}
            setValue={setTypeParticipation}
            isError={typeParticipationError !== ''}
            error={typeParticipationError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.nom2}
            value={nom2}
            setValue={setNom2}
            isError={nom2Error !== ''}
            error={nom2Error}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.nom3}
            value={nom3}
            setValue={setNom3}
            isError={nom3Error !== ''}
            error={nom3Error}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.nom4}
            value={nom4}
            setValue={setNom4}
            isError={nom4Error !== ''}
            error={nom4Error}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.coach}
            value={coach}
            setValue={setCoach}
            isError={coachError !== ''}
            error={coachError}
          />
          <CustomSelect
            items={[
              {id: 1, value: 'Afrique', label: getLang(lang).firstWorldCup.nationaliteItems[0]},
              {id: 2, value: 'Europe', label: getLang(lang).firstWorldCup.nationaliteItems[1]},
              {id: 3, value: 'Amérique', label: getLang(lang).firstWorldCup.nationaliteItems[2]},
              {id: 4, value: 'Asie', label: getLang(lang).firstWorldCup.nationaliteItems[3]},
            ]}
            placeholder={getLang(lang).firstWorldCup.nationalite}
            value={nationalite}
            setValue={setNationalite}
            isError={nationaliteError !== ''}
            error={nationaliteError}
          />
          <CustomSelect
            items={[
              {id: 1, value: 'Maroc', label: getLang(lang).firstWorldCup.paysItems[0]},
              {id: 2, value: 'Autre', label: getLang(lang).firstWorldCup.paysItems[1]},
            ]}
            placeholder={getLang(lang).firstWorldCup.pays}
            value={pays}
            setValue={setPays}
            isError={paysError !== ''}
            error={paysError}
          />
          {pays === 'Autre'
          && (
            <CustomInput
              type='text'
              placeholder={getLang(lang).firstWorldCup.pays}
              value={autrePays}
              setValue={setAutrePays}
              isError={autrePaysError !== ''}
              error={autrePaysError}
            />
          )}
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.ville}
            value={ville}
            setValue={setVille}
            isError={villeError !== ''}
            error={villeError}
          />
          <CustomInput
            type='tel'
            placeholder={getLang(lang).firstWorldCup.tel}
            value={tel}
            setValue={setTel}
            isError={telError !== ''}
            error={telError}
          />
          <CustomInput
            type='email'
            placeholder={getLang(lang).firstWorldCup.email}
            value={email}
            setValue={setEmail}
            isError={emailError !== ''}
            error={emailError}
          />
          <CustomButton
            value={getLang(lang).firstWorldCup.inscrir}
            handelClick={sendInscription}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
